import { useContext } from 'react';
import { useHistory } from 'react-router';

import { TariffDirection } from '../../../api/Optimise';
import { AppContext } from '../../../context/AppContext';
import EnergyIcon from '../../EnergyIcon';
import SmartTariffWarning from '../../SmartTariffWarning';
import { StyledH3, StyledHr } from '../../Styled';

import InformationPanel from './InformationPanel';

const TariffInformation = () => {
  const history = useHistory();
  const { userDetails } = useContext(AppContext);
  const isLoadingUserDetails = !userDetails;

  return (
    <>
      {!userDetails?.has_smart_tariff && !isLoadingUserDetails && (
        <>
          <StyledH3 className="d-flex justify-content-between mt-4">
            <span>{'Tariff information'}</span>{' '}
          </StyledH3>
          <SmartTariffWarning
            linkText="Open tariff recommender."
            linkAction={() => {
              history.push(`/app/tariffs`);
            }}
            styleOverride={{ marginTop: 0 }}
          />
        </>
      )}
      {userDetails?.has_smart_tariff && !isLoadingUserDetails && (
        <InformationPanel
          title="Tariff information"
          isLoading={!userDetails?.tariffs}
          loadingLines={4}
          onEdit={() => history.push('/edit/tariff')}
        >
          <div className="d-flex">
            <EnergyIcon direction={TariffDirection.IMPORT} />
            <div className="pl-2">
              <li>Import energy provider: {userDetails?.tariffs.import_tariff.supplier}</li>
              <li>Import tariff: {userDetails?.tariffs.import_tariff.tariff_name}</li>
            </div>
          </div>
          <StyledHr />
          <div className="d-flex">
            <EnergyIcon direction={TariffDirection.EXPORT} />
            <div className="pl-2">
              <li>Export energy provider: {userDetails?.tariffs.export_tariff.supplier}</li>
              <li>Export tariff: {userDetails?.tariffs.export_tariff.tariff_name}</li>
            </div>
          </div>
        </InformationPanel>
      )}
    </>
  );
};

export default TariffInformation;
